<template>
  <v-dialog v-model="dialog" :width="width" persistent>
    <v-card :loading="loading">
      <v-card-title>
        {{ title }}
        <v-spacer></v-spacer>
        <v-btn @click="close()" icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-subtitle v-if="subtitle">
        {{ subtitle }}
      </v-card-subtitle>

      <v-card-actions v-if="actions" class="pl-6">
        <v-btn
          v-for="action in actions"
          :key="action.name"
          @click="$emit('click:' + action.name)"
          :color="action.color || ''"
          :dark="action.dark || false"
        >
          <v-icon v-if="action.icon" left>{{ action.icon }}</v-icon>
          {{ action.text }}
        </v-btn>
      </v-card-actions>

      <v-card-text v-if="loading" height="200">
        <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
        <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
        <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
        <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
        <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
      </v-card-text>

      <v-list v-else>
        <v-list-item v-if="!items.length" class="text-center grey--text">
          <v-list-item-content>
            <v-list-item-title>
              {{ emptyMessage }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <template v-for="item in items">
          <slot :name="`item.${item[itemKey]}`">
            <v-list-item
              :key="item[itemKey]"
              @click="$emit('click:item', item)"
            >
              <v-list-item-content>
                <v-list-item-title>
                  <slot name="item.title" :item="item">
                    {{ itemTitle ? item[itemTitle] : "" }}
                  </slot>
                </v-list-item-title>

                <v-list-item-subtitle>
                  <slot name="item.subtitle" :item="item">
                    {{ itemSubtitle ? item[itemSubtitle] : "" }}
                  </slot>
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-icon v-if="itemIcon">
                <v-icon>{{ itemIcon }}</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </slot>
        </template>
      </v-list>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    itemKey: {
      type: String,
      default: "id"
    },
    itemTitle: String,
    itemSubtitle: String,
    itemIcon: String,
    width: {
      type: Number,
      default: 600
    },
    emptyMessage: {
      type: String,
      default: "Nenhum item encontrado"
    },
    actions: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      dialog: false,
      title: "",
      subtitle: "",
      items: [],
      loading: false
    };
  },

  methods: {
    close() {
      this.dialog = false;
    },

    open(title, subtitle = "") {
      this.title = title;
      this.subtitle = subtitle;
      this.items = [];
      this.dialog = true;
    },

    setLoading(loading) {
      this.loading = loading;
    }
  }
};
</script>
